.Button {
  &:focus {
    outline: var(--focus-outline);
  }
}
